import { inputControlTypes } from '@deity-io/di-data-basics';
import type { IDefinitionField } from '@deity-io/di-data-definitions';
import type { IPropertyListItem } from '@deity-io/di-data-structure-editor';

export const getInputControlType = (property: IPropertyListItem, owner: any): string | undefined => {
  if (property.inputControl) {
    if (property.inputControl === inputControlTypes.fieldType) {
      // Get control type from FieldType. TODO make this better
      if (owner) {
        return (owner as IDefinitionField).fieldType?.nativeType;
      }

      return 'error';
    }

    return property.inputControl;
  }
  if ('nativeType' in property) {
    return property.nativeType;
  }

  return undefined;
};

export const hasAControl = (inputControlType: string): boolean => {
  switch (inputControlType) {
    case inputControlTypes.options:
    case inputControlTypes.boolean:
    case inputControlTypes.dateTime:
    case inputControlTypes.string:
    case inputControlTypes.number:
    case inputControlTypes.dictionary:
    case inputControlTypes.freeSoloList:
    case inputControlTypes.structurePicker:
      return true;
    case undefined:
    case 'error':
      return true;
    case inputControlTypes.jsonEditor:
    case inputControlTypes.list:
    case inputControlTypes.mapping: // Flow
    case inputControlTypes.port: // Flow
    case inputControlTypes.restEndpoint: // Flow
    case inputControlTypes.schemaObjectPathPicker: // Flow
    case inputControlTypes.schemaPathPicker: // Flow
    case inputControlTypes.endpointPicker: // Flow
    case inputControlTypes.hidden:
    default:
      // Todo, a field without input control. but with children that have them (properties)
      return false;
  }
};
